<template>
  <BContainer
    class="px-0"
    fluid
  >
    <BSkeletonWrapper
      :loading="loading"
    >
      <template #loading>
        <div
          class="iq-card user-profile mb-0 shadow-none border"
        >
          <div class="iq-card-body profile-page p-0">
            <div class="profile-header p-4">
              <div class="profile-info">
                <div class="row">
                  <div class="col-12">
                    <div class="user-details pl-md-3">
                      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center">
                        <div class="profile-img mb-3 mb-md-0">
                          <div class="profile-overlay-container">
                            <BSkeleton
                              type="avatar"
                              size="130px"
                              variant="primary"
                            />
                            <div class="profile-overlay-middle">
                              <BSkeleton
                                type="avatar"
                                size="38px"
                                variant="dark"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center align-items-md-start pl-md-3">
                          <BSkeleton
                            width="260px"
                            height="25px"
                          />
                          <BSkeleton width="50px" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12 col-md-6" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        class="iq-card user-profile mb-0 shadow-none border"
      >
        <div class="iq-card-body profile-page p-0">
          <div class="profile-header p-4">
            <div class="profile-info">
              <div class="row">
                <div class="col-12">
                  <div class="user-details pl-md-3">
                    <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center">
                      <div class="profile-img mb-3 mb-md-0">
                        <div class="profile-overlay-container">
                          <BAvatar
                            v-if="userStorage.photo_url"
                            :src="cProfilePath"
                            variant="primary"
                            size="130px"
                          />
                          <BAvatar
                            v-else
                            variant="primary"
                            size="130px"
                            :text="String(userStorage.first_name).charAt(0) + String(userStorage.last_name).charAt(0)"
                          />
                          <div class="profile-overlay-middle">
                            <BButton
                              class="py"
                              style="border-radius: 50%;"
                              variant="dark"
                              @click.prevent="editPicture"
                            >
                              <i
                                class="fad fa-camera p-0"
                                style="font-size: 12px;"
                              />
                            </BButton>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column align-items-center align-items-md-start pl-md-3">
                        <h5 class="text-capitalize">
                          {{ userStorage.name }}
                        </h5>
                        <p class="m-0">
                          {{ userStorage.role_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 col-md-6" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </BSkeletonWrapper>

    <BModal
      ref="modalPicture"
      size="sm"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="full-height w-md-350px"
      modal-class="full-height"
      aria-hidden="false"
      role="dialog"
    >
      <ValidationObserver
        ref="formPicture"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <div
            class="d-flex justify-content-center align-items-center pt-2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="file"
              name="photo"
              rules="required|image"
            >
              <BFormGroup
                label="Upload Profile"
                label-for="fUploadProfile"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormFile
                  id="fUploadProfile"
                  v-model="formPicture.photo"
                  placeholder="Choose a profile..."
                  drop-placeholder="Drop file here..."
                  accept=".jpg,.jpeg,.png"
                  style="width: 300px;"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy"
                  @change="convertPicture"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </div>
          <div
            class="d-flex justify-content-center align-items-center pt-3"
            style="min-height: 325px;"
          >
            <div class="cropper-container">
              <cropper-canvas
                ref="cropperCanvas"
                style="height: 300px; width: 300px;"
                class="border border-primary rounded"
              >
                <cropper-image
                  v-if="formPicture.file"
                  ref="cropperImage"
                  alt="Picture"
                  rotatable
                  scalable
                  skewable
                  translatable
                  :src="formPicture.file"
                />
                <cropper-selection
                  ref="cropperSelection"
                  x="10"
                  y="10"
                  width="280"
                  height="280"
                  multiple
                  keyboard
                  aspect-ratio="1"
                  style="border-radius: 50%;"
                >
                  <cropper-grid
                    role="grid"
                    covered
                    rows="0"
                    columns="0"
                  />
                  <cropper-crosshair centered />
                  <cropper-handle
                    action="move"
                    theme-color="rgba(255, 255, 255, 0)"
                  />
                </cropper-selection>
              </cropper-canvas>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <BButton
          variant="primary"
          :disabled="state.busy"
          @click.prevent="validatePicture"
        >
          Change Profile
        </BButton>
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import 'cropperjs'
import { mapActions, mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'

import { SSharedProfile } from '@/services/shared'

export default {
  name: 'VAccountProfilePictures',

  mixins: [
    MxMisc
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },

    user: {
      type: Object,
      default: () => ({
        id: '',
        username: '',
        name: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        email: '',
        notification_email: '',
        role: '',
        role_name: '',
        area: '',
        provinces: [],
        photo_url: ''
      })
    }
  },

  emits: ['updated'],

  data () {
    return {
      state: {
        busy: false
      },
      formPicture: {
        photo: null,
        file: ''
      }
    }
  },

  computed: Object.assign({
    cProfilePath () {
      const photoPath = this.userStorage?.photo_url
      if (photoPath) {
        const apiBase = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '')
        const filename = photoPath.split('/').pop()

        if (filename && photoPath.startsWith('profile-photos/')) {
          return `${apiBase}/shared/uploads/profile-photos/view/${encodeURIComponent(filename)}`
        }

        return `${(process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '')}/${photoPath}`
      }

      return `${window.location.origin}/img/invalid-image.png`
    }
  }, mapGetters({
    userStorage: 'auth/user'
  })),

  methods: {

    ...mapActions({
      updateUserStorage: 'auth/fetchUserSuccess'
    }),

    convertPicture ({ target }) {
      if (target.files.length === 0) {
        this.formPicture.file = ''
        return
      }

      this.formPicture.file = URL.createObjectURL(target.files[0])
    },

    editPicture () {
      this.formPicture.file = ''

      this.$refs.modalPicture.show()

      this.$refs.modalPicture.onAfterEnter = () => {
        this.$refs.cropperSelection.$center()
      }
    },

    validatePicture () {
      this.$refs.formPicture.validate().then(
        validPicture => {
          if (!validPicture) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: 'Change your current Profile Picture?',
            confirmButtonText: 'Change Profile',
            cancelButtonText: 'Discard',
            preConfirm: async () => {
              this.state.busy = true

              const createOrUpdate = async () => {
                return this.postPicture()
              }

              return createOrUpdate().catch(
                ({ message }) => {
                  this.$refs.formInteraction.setErrors(message.errors)
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    postPicture () {
      return new Promise((resolve, reject) => {
        this.$refs.cropperCanvas.$toCanvas().then(
          canvas => {
            const payload = new FormData()
            payload.append('user_id', this.user.id)

            canvas.toBlob(
              fileBlob => {
                payload.append('file', fileBlob, 'profile.png')

                SSharedProfile.post(payload).then(
                  ({ data: { message, photo_url: photoUrl } }) => {
                    this.swalSuccess(message).then(() => {
                      this.updateUserStorage(
                        Object.assign(this.userStorage, {
                          photo_url: photoUrl
                        })
                      )

                      this.$refs.modalPicture.hide()
                    })
                    resolve(message)
                  }
                ).catch(reject)
              },
              'image/png'
            )
          }
        )
      })
    }

  }

}
</script>
<style lang="scss">
  .profile-overlay-container {
    position: relative;
    width: 100%;
  }

  .profile-overlay-middle {
    bottom: 0;
    right: 0;
    position: absolute;
  }
</style>
